'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _EditCaseNoteModal = require('../page-case/sidebar-feed/EditCaseNoteModal');

var _EditCaseNoteModal2 = _interopRequireDefault(_EditCaseNoteModal);

var _utils = require('../../utils');

var _util = require('../../utils/util');

var _common = require('../common');

var _CaseActivityActionFooter = require('./CaseActivityActionFooter');

var _CaseActivityActionFooter2 = _interopRequireDefault(_CaseActivityActionFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CaseActivity = (_dec = (0, _mobxReact.inject)('CaseStore', 'SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(CaseActivity, _Component);

  function CaseActivity() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CaseActivity);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CaseActivity.__proto__ || Object.getPrototypeOf(CaseActivity)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showConfirmDelete', _descriptor, _this), _initDefineProp(_this, 'showEditModal', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CaseActivity, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.showConfirmDelete = false;
    }
  }, {
    key: 'onClickDelete',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, CaseStore, activity;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, CaseStore = _props.CaseStore, activity = _props.activity;
                _context.next = 3;
                return CaseStore.deleteCaseActivity(activity);

              case 3:
                this.showConfirmDelete = false;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onClickDelete() {
        return _ref2.apply(this, arguments);
      }

      return onClickDelete;
    }()
  }, {
    key: 'onShowConfirmDelete',
    value: function onShowConfirmDelete() {
      this.showConfirmDelete = true;
    }
  }, {
    key: 'onClickEdit',
    value: function onClickEdit() {
      this.showEditModal.setTrue();
    }
  }, {
    key: 'onHideConfirmDelete',
    value: function onHideConfirmDelete() {
      this.showConfirmDelete = false;
    }
  }, {
    key: 'handleEditNoteSubmit',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(note) {
        var CaseStore;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                CaseStore = this.props.CaseStore;
                _context2.next = 3;
                return CaseStore.editCaseNote(note);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleEditNoteSubmit(_x) {
        return _ref3.apply(this, arguments);
      }

      return handleEditNoteSubmit;
    }()
  }, {
    key: 'renderDot',
    value: function renderDot() {
      var _props2 = this.props,
          dot = _props2.dot,
          icon = _props2.icon;


      if (dot === 'name') {
        return _react2.default.createElement(
          'div',
          { className: 'dot name' },
          this.byPersonInitials
        );
      }

      if (dot === 'icon') {
        return _react2.default.createElement(
          'div',
          { className: 'dot icon' },
          icon && _react2.default.createElement(_common.Icon, { type: icon })
        );
      }

      // dot === small
      return _react2.default.createElement('div', { className: 'dot small' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          activity = _props3.activity,
          activity_body = _props3.activity_body,
          onClick = _props3.onClick,
          truncateBody = _props3.truncateBody,
          truncatedBody = _props3.truncatedBody,
          deleted_at = activity.deleted_at,
          id = activity.id,
          type = activity.type,
          isDeleted = !!deleted_at;


      return _react2.default.createElement(
        'div',
        { key: id, className: (0, _classnames2.default)('activity-item', { 'deleted': isDeleted }), 'data-type': type, onClick: onClick },
        this.renderDot(),
        _react2.default.createElement(
          'div',
          { className: 'body' },
          truncateBody && truncatedBody || activity_body
        ),
        _react2.default.createElement(_CaseActivityActionFooter2.default, {
          activity: activity,
          isDeletable: this.isDeletable,
          onClickDelete: this.onShowConfirmDelete,
          onClickEdit: this.onClickEdit
        }),
        _react2.default.createElement(_common.ConfirmDelete, {
          message: 'Delete this note?',
          showConfirmDelete: this.isDeletable && this.showConfirmDelete,
          onClickDelete: this.onClickDelete,
          onClickCancel: this.onHideConfirmDelete
        }),
        this.showEditModal.isTrue && _react2.default.createElement(_EditCaseNoteModal2.default, {
          _note: activity,
          onClose: this.showEditModal.setFalse,
          onSubmit: this.handleEditNoteSubmit
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'isDeletable',
    get: function get() {
      var _props4 = this.props,
          activity = _props4.activity,
          deletableActivityType = _props4.deletableActivityType,
          enableDelete = _props4.enableDelete,
          SessionStore = _props4.SessionStore,
          deleted_at = activity.deleted_at,
          isDeleted = !!deleted_at;


      if (!activity.by_person) {
        return false;
      }

      return enableDelete && deletableActivityType && !isDeleted && SessionStore.user.id === activity.by_person.id;
    }
  }, {
    key: 'byPersonInitials',
    get: function get() {
      var by_person = (0, _get3.default)(this.props, 'activity.by_person'),
          first = (0, _get3.default)(by_person, 'first_name'),
          last = (0, _get3.default)(by_person, 'last_name');

      if (first && last) {
        return (0, _util.getInitials)(first, last);
      }

      return null;
    }
  }]);

  return CaseActivity;
}(_react.Component), _class3.defaultProps = {
  deletableActivityType: false,
  dot: 'name',
  enableDelete: false,
  truncateBody: false
}, _class3.propTypes = {
  activity: _propTypes2.default.shape({ id: _propTypes2.default.string.isRequired, type: _propTypes2.default.string.isRequired }).isRequired,
  activity_body: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),
  CaseStore: _propTypes2.default.object,
  deletableActivityType: _propTypes2.default.bool,
  dot: _propTypes2.default.string,
  enableDelete: _propTypes2.default.bool,
  icon: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  SessionStore: _propTypes2.default.object,
  truncateBody: _propTypes2.default.bool,
  truncatedBody: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array])
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showConfirmDelete', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'showEditModal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool();
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'componentWillMount', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'componentWillMount'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onClickDelete', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onClickDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onShowConfirmDelete', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onShowConfirmDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onClickEdit', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onClickEdit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onHideConfirmDelete', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onHideConfirmDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleEditNoteSubmit', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleEditNoteSubmit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = CaseActivity;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CaseActivity, 'CaseActivity', '/app/src/components/common-activities/CaseActivity.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/CaseActivity.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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